import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import {
  REASON_MAX,
} from '../../../../../Consts/billing-documents.const';
import {
  DocumentReasonDialogData,
  DocumentReasonDialogResult,
} from '../../../Interfaces/billing-dialog.interface';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-document-reason-dialog',
  standalone: true,
  imports: [ReactiveFormsModule, MatDialogModule, TranslateModule],
  templateUrl: './document-reason-dialog.component.html',
  styleUrl: './document-reason-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DocumentReasonDialogComponent {
  private readonly _formBuilder = inject(FormBuilder);
  private readonly _dialogRef =
    inject<MatDialogRef<DocumentReasonDialogComponent, DocumentReasonDialogResult>>(MatDialogRef);

  readonly data = inject<DocumentReasonDialogData>(MAT_DIALOG_DATA);

  readonly reasonMax = REASON_MAX;

  readonly formGroup: FormGroup = this._formBuilder.group({
    reason: [
      '',
      this.data.isReasonRequired
        ? [Validators.required, Validators.maxLength(REASON_MAX)]
        : [Validators.maxLength(REASON_MAX)],
    ],
  });

  confirm(): void {
    if (!this.formGroup.valid) {
      return;
    }

    this._dialogRef.close({ reason: String(this.formGroup.value.reason ?? '').trim() });
  }

  dismiss(): void {
    this._dialogRef.close();
  }
}
